module.exports = __webpack_public_path__ + "media/images/area/icon_weather_3-e62195f53941c76690b884cb76588571.png";